export function convertToIST(dateString) {
  // Parse the date string into a Date object (in UTC)
  const dateUTC = new Date(dateString);

  // Format the date to "28 Jan, 2025"
  const formattedDate = dateUTC.toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });

  // Format the time to "7:20 AM"
  const formattedTime = dateUTC.toLocaleTimeString('en-IN', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });

  return { date: formattedDate, time: formattedTime };
}

// A date as the browser's local "YYYY-MM-DDTHH:mm" (datetime-local inputs) or,
// with length 10, "YYYY-MM-DD". toISOString() would give UTC: 09:00 in India
// showed as 03:30 and was saved back shifted.
export function toLocalInputValue(date = new Date(), length = 16) {
  const d = new Date(date);
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000)
    .toISOString()
    .slice(0, length);
}
